import { createReducer } from 'redux-create-reducer';
import {
  requestCustomersAction,
  receiveCustomersAction,
} from '../actions/customers';

const initialState = {
  choice: [],
  current: undefined,
  isFetching: false,
};

export const customersReducer = createReducer(initialState, {
  [requestCustomersAction]: state => {
    return {
      ...state,
      isFetching: true,
    };
  },
  [receiveCustomersAction]: (state, action) => {
    return {
      ...state,
      choice: action.payload,
      isFetching: false,
    };
  },
});

export default customersReducer;

export const getCustomers = state => state.customers.choice;
export const getIsFetching = state => state.customers.isFetching;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/common/modals/case-transfer/reducers/customers.js